import util from '../../../util/index';
export default {
  filters: {
    removeHttp: util.removeHttp
  },
  methods: {
    removeHttp: util.removeHttp
  },
  directives: {
    htmlText: {
      bind: function bind(el, binding, vnode, oldVnode) {
        if (binding.value !== null) {
          el.innerHTML = binding.value;
        }
      },
      update: function update(el, binding, vnode, oldVnode) {
        binding.def.bind(el, binding, vnode, oldVnode);
      }
    }
  }
};